import {Dimensions, ManuallyEditableMetadata, SubmissionItem} from "./SubmissionItem";
import {action, computed, makeObservable, observable} from "mobx";
import {ImageApi, ImageOpts} from "../image/ImageApi";
import {none, Option, option, some} from "ts-option/index";
import * as _ from "lodash";

export class MobxSubmissionItem implements SubmissionItem {
  id: string
  fileName: string
  contentType: string
  url: string
  key: string
  saved: boolean = false
  dirty: boolean = false
  metadata: Object
  imageRef: (opts: ImageOpts) => { width: number; url: any; height: number } = null
  sortKey: number
  unsavedMetadata: Option<ManuallyEditableMetadata> = none

  constructor(id: string, fileName: string, url: string, contentType: string, key: string, sortKey: number, metadata?: Object) {
    this.id = id
    this.fileName = fileName
    this.url = url
    this.contentType = contentType
    this.key = key
    this.imageRef = ImageApi.resized(url, contentType)
    this.sortKey = sortKey
    this.metadata = metadata

    makeObservable(this, {
      saved: observable,
      dirty: observable,
      setSaved: action,
      setDirty: action,
      creator: computed,
      caption: computed,
      source: computed,
      preSave: action,
      setMetadata: action
    })
  }

  update(metadata: ManuallyEditableMetadata): void {
    if (metadata.caption !== this.caption || metadata.creator !== this.creator || metadata.source !== this.source) {
      this.setDirty()
      this.unsavedMetadata = some(metadata)
    }
  }

  get creator(): string {
    return (
      option(this.metadata)
        .flatMap(metadata => option(metadata.creator)
          .orElse(() => option(metadata.Creator).orElse(() => option(metadata.Byline))))
        .getOrElse(() => undefined)
    );
  }

  get caption(): string {
    return (
      option(this.metadata)
        .flatMap(metadata => option(metadata.caption).orElse(() => option(metadata.description).map(d => d.value)))
        .getOrElse(() => undefined)
    )
  }

  get source(): string {
    return (
      option(this.metadata)
        .flatMap(metadata => option(metadata.source).orElse(() => option(metadata.Credit)))
        .getOrElse(() => undefined)
    )
  }

  get dimensions(): Promise<Dimensions> {
    const w = option(this.metadata.ImageWidth).orElse(() => option(this.metadata.EXIFImageWidth))
    const h = option(this.metadata.ImageHeight).orElse(() => option(this.metadata.EXIFImageHeight))

    return new Promise(w.flatMap(ww => h.map(hh => ({width: ww, height: hh}))).getOrElse(() => undefined))
  }

  setMetadata(m: any) {
    this.metadata = m
  }

  preSave() {
    this.unsavedMetadata.forEach(edited => {
      this.setMetadata(
        _.assign(
          {
            caption: edited.caption || this.caption,
            creator: edited.creator || this.creator,
            source: edited.source || this.source
          }
        )
      )
    })
  }

  setSaved() {
    this.unsavedMetadata = none
    this.saved = true
    this.dirty = false
  }

  setDirty() {
    this.dirty = true
  }
}



